<template>
    <div>
        <vue-headful title="New Incident :: MeritEHS" />

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/incidents`">
                        <i class="fa fa-stethoscope"></i> Incidents
                    </router-link>
                </li>
                <li class="breadcrumb-item active">New Incident</li>
                <li class="ml-3">
                    <button type="button" class="btn btn-sm btn-success" v-on:click="saveIncident(this)" :disabled="saving">
                        <span v-if="saving">Saving...</span>
                        <span v-else>Create</span>
                        Incident
                    </button>
                </li>
            </ol>
        </h4>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-xl-10 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header"><strong>Create a New Incident</strong></div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteId }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteId }">
                                    Jobsite: <i class="fa fa-asterisk text-danger small" v-if="no_jobsite_set != 1 && is_other_location != 1 && !incident.JobsiteId"></i>
                                </label>
                                <div class="col-sm-8">

                                    <jobsite-select ref="inciJobsiteSelect" :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.JobsiteId ? true : false"></jobsite-select>

                                    <template v-if="this.$root.hasPermission('jobsites.manage')">
                                        <div class="mt-1 mb-1">
                                            <a href="javascript:void(0)" v-on:click="showNewJobsiteModal()"><small><i class="fa fa-plus"></i> Create a New Jobsite</small></a>
                                        </div>

                                        <div>
                                            <jobsite-modal ref="newJobsiteModal" @jobsiteCreated="jobsiteCreated" :showButton="false" />
                                        </div>
                                    </template>

                                    <span v-if="errors.JobsiteId" class="text-danger">
                                        <span v-for="error in errors.JobsiteId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <template v-if="incident.IncidentTypeId && incidentTypeSettings[incident.IncidentTypeId].inci_require_jobsite == 0">
                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">No Jobsite:</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="no_jobsite_set" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                                    </div>
                                </div>
                            </template>

                            <template v-if="account.inci_enable_other_location == 1">
                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Is Other Location?</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="is_other_location" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                                    </div>
                                </div>

                                <div class="form-group row" v-if="is_other_location == 1">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_location }">
                                        Other Location:
                                        <i v-if="no_jobsite_set != 1 && !incident.other_location" class="fa fa-asterisk text-danger small"></i>
                                    </label>
                                    <div class="col-sm-8">

                                        <b-form-input v-model="incident.other_location" type="text" placeholder="Enter the Other Location" :class="{'is-invalid': errors.other_location}"></b-form-input>

                                        <span v-if="errors.other_location" class="text-danger">
                                            <span v-for="error in errors.other_location">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <template v-if="(this.$store.state.user.subcontractor_id && this.$root.hasPermission('employees.view')) || !this.$store.state.user.subcontractor_id">
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.EmployeeId }" class="row">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.EmployeeId }">
                                        Employee: <i v-if="incident.IsTempEmployee != 1 && !incident.EmployeeId" class="fa fa-asterisk text-danger small"></i>
                                    </label>
                                    <div class="col-sm-8">

                                        <employee-select ref="employeeSelector" :selectedValues="EmployeeValues" @vselected="onEmployeeSelect" :hasError="errors.EmployeeId ? true : false"></employee-select>

                                        <span v-if="errors.EmployeeId" class="text-danger">
                                            <span v-for="(error,i) in errors.EmployeeId"><span v-if="i > 0">. </span>{{ error }}</span>
                                        </span>

                                        <template  v-if="this.$root.hasPermission('employees.manage')">
                                            <div class="mt-1 mb-1">
                                                <a href="javascript:void(0)" v-on:click="showNewEmployeeModal()"><small><i class="fa fa-plus"></i> Create a New Employee</small></a>
                                            </div>

                                            <div>
                                                <employee-modal ref="newEmployeeModal" @employeeCreated="employeeCreated" :showButton="false" />
                                            </div>
                                        </template>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Other Employee?</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="incident.IsTempEmployee" value="1" unchecked-value="0" plain>
                                            <span class="small">Check if Employee is Temporary Labor, a Subcontractor Employee, or Other.</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="incident.IsTempEmployee == 1">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.TempEmployeeName }">
                                        Other Employee Name:<i v-if="!incident.TempEmployeeName" class="fa fa-asterisk text-danger small"></i>
                                    </label>
                                    <div class="col-sm-8">

                                        <b-form-input v-model="incident.TempEmployeeName" type="text" placeholder="Enter Temporary, Subcontractor, or Other Employee Name" :class="{'is-invalid': errors.TempEmployeeName}"></b-form-input>

                                        <span v-if="errors.TempEmployeeName" class="text-danger">
                                            <span v-for="error in errors.TempEmployeeName">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group row">
                                <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Is Subcontractor?:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="incident.IsContractor" value="1" unchecked-value="0" plain></b-form-checkbox>
                                </div>
                            </div>

                            <template v-if="incident.IsContractor == 1">
                                <div class="form-group row">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subcontractor_id }">
                                        Subcontractor: <i v-if="!incident.subcontractor_id && incident.is_other_subcontractor != 1" class="fa fa-asterisk text-danger small"></i>
                                    </label>
                                    <div class="col-sm-8">
                                        <b-form-select v-model="incident.subcontractor_id"
                                            :options="subcontractorOptions"
                                            :state="errors.subcontractor_id ? false : null"
                                            :disabled="incident.is_other_subcontractor == 1" />

                                        <template  v-if="this.$root.hasPermission('subcontractors.manage') && incident.is_other_subcontractor != 1">
                                            <div class="mt-2">
                                                <subcontractor-modal :showButton="true" @subcontractorCreated="subcontractorCreated" />
                                            </div>
                                        </template>

                                        <span v-if="errors.subcontractor_id" class="text-danger">
                                            <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Other Subcontractor?</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="incident.is_other_subcontractor" value="1" unchecked-value="0" plain>
                                            <span class="small">Check if the Subcontractor is not in your list of known subs. This will enable a Free Text Subcontractor Name field.</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="incident.is_other_subcontractor == 1">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.ContractorCompany }">
                                        Other Subcontractor Name: <i v-if="!incident.ContractorCompany" class="fa fa-asterisk text-danger small"></i>
                                    </label>
                                    <div class="col-sm-8">
                                        <b-form-input v-model="incident.ContractorCompany" type="text" placeholder="Enter Subcontractor Company Name" :class="{'is-invalid': errors.ContractorCompany}"></b-form-input>

                                        <span v-if="errors.ContractorCompany" class="text-danger">
                                            <span v-for="error in errors.ContractorCompany">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IncidentTypeId }">Type of Incident: <i v-if="!incident.IncidentTypeId" class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="incident.IncidentTypeId" :options="typeOptions" :class="{'is-invalid': errors.IncidentTypeId}"></b-form-select>

                                    <span v-if="errors.IncidentTypeId" class="text-danger">
                                        <span v-for="error in errors.IncidentTypeId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IncidentDate }">Date of Incident: <i v-if="!incident.IncidentDate" class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <b-form-input v-model="incident.IncidentDate" type="date" :class="{ 'is-invalid': errors.IncidentDate }" placeholder="Enter the Date of the Incident" />

                                    <span v-if="errors.IncidentDate" class="text-danger">
                                        <span v-for="error in errors.IncidentDate">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="account.inci_req_desc_on_create == 1">
                        <div :class="{ 'card-header': true, 'text-danger': errors.DetailedDescription }">
                            <strong>Detailed Description of Incident </strong>
                            <i v-if="!incident.DetailedDescription" class="fa fa-asterisk text-danger small"></i>
                        </div>
                        <div :class="{'card-body': true}">
                            <vue-editor v-model="incident.DetailedDescription" placeholder="Enter a Detailed Description of the Incident" :editor-toolbar="this.$root.customVueEditorToolbar"></vue-editor>
                            <span v-if="errors.DetailedDescription" class="text-danger">
                                <span v-for="error in errors.DetailedDescription">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div :class="{ 'card-header': true, 'text-danger': errors.files }">
                            <strong>Initial Files/Photos </strong>
                        </div>
                        <div class="card-body">
                            <div v-bind:class="{'has-error': errors.files }" class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Files/Photos:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-file v-model="files" multiple placeholder="Add Files, Photos, or Other Documents"></b-form-file>

                                    <span v-if="errors.files" class="text-danger">
                                        <span v-for="error in errors.files">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="alert alert-info">
                                In Order to prevent data loss, enter the basic Incident information above and then create the incident. EHS will then load the entire Incident Form and auto-save the incident in the background to prevent data loss.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveIncident(this)" :disabled="saving">
                <span v-if="saving">Saving...</span>
                <span v-else>Create</span>
                Incident
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                incident: {
                    IncidentTypeId: null,
                    JobsiteId: null,
                },
                incidentTypes: {},
                incidentTypeSettings: {},
                account: {},
                errors: {},
                subcontractors: [],
                files: [],
                is_other_location: 0,
                no_jobsite_set: 0,
            }
        },

        computed: {
            typeOptions(){
                //Setup
                var options = [{value: null, text: '-- Select an Incident Type --'}];

                //Loop and Build
                for(var i = 0; i < this.incidentTypes.length; i++)
                {
                    options.push({value: this.incidentTypes[i].IncidentTypeId, text: this.incidentTypes[i].TypeName});
                }

                //Send it
                return options;
            },

            JobsiteValues(){
                //check for null
                if(!this.incident.JobsiteId || this.incident.JobsiteId == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite && this.is_other_location == 0 && this.incident.no_jobsite_set != 1)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.incident.JobsiteId = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.incident.JobsiteId, JobsiteNumber: this.incident.JobsiteNumber, JobsiteName: this.incident.JobsiteName};
            },

            EmployeeValues(){
                //check for null
                if(!this.incident.EmployeeId)
                {
                    return null;
                }

                return {EmployeeId: this.incident.EmployeeId, FirstName: this.incident.EmployeeFirstName, LastName: this.incident.EmployeeLastName, EmployeeNumber: this.incident.EmployeeEmployeeNumber};
            },

            //Major Body Part Options
            subcontractorOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select Subcontractor --'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.subcontractors.length; i++)
                {
                    //Push onto options
                    options.push({value: this.subcontractors[i].subcontractor_id, text: this.subcontractors[i].subcontractor_name});
                }

                //Send it
                return options;
            },
        },

        watch: {
            is_other_location(newValue, oldValue){
                // Don't run this watcher if we're trying to nuke all location data
                if (this.no_jobsite_set == 1)
                {
                    return;
                }

                //Set the Jobsite to NULL
                if(newValue == 1)
                {
                    this.incident.JobsiteId = null;
                    this.$refs.inciJobsiteSelect.clearInput();
                }
                else
                {
                    this.$refs.inciJobsiteSelect.setValue(this.JobsiteValues);
                    this.incident.other_location = null;
                }
            },

            'incident.is_other_subcontractor'(newVal, oldVal){
                //Check for 1
                if(newVal == 1)
                {
                    //Clear the value
                    this.incident.subcontractor_id = null;
                }
                else
                {
                    //Clear the plain text value
                    this.incident.ContractorCompany = null;
                }
            },

            no_jobsite_set(newValue, oldValue){
                //Set the Jobsite to NULL
                if(newValue == 1)
                {
                    this.$refs.inciJobsiteSelect.clearInput();
                    this.is_other_location = 0;
                    this.incident.other_location = null;
                }
                else
                {
                    this.$refs.inciJobsiteSelect.setValue(this.JobsiteValues);
                }
            },
        },

        methods: {
            // Convert database date to human
            readDate(date) {
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            },

            // Convert human date to database
            writeDate(date) {
                return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
            },

            //Get the Various Resources We Need to Edit a Incident
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.incident.JobsiteId = null;
                    return;
                }

                //Send the value
                this.incident.JobsiteId = jobsite.JobsiteId;
                //this.incident.JobsiteName = jobsite.JobsiteName;
                //this.incident.JobsiteNumber = jobsite.JobsiteNumber;
            },

            jobsiteCreated(jobsite){
                //How do we show the
                this.incident.JobsiteId = jobsite.JobsiteId;
                this.incident.JobsiteNumber = jobsite.JobsiteNumber;
                this.incident.JobsiteName = jobsite.JobsiteName;

                //We have to call the employee-select helper function
                //because component props are ONE WAY databound.
                this.$refs.inciJobsiteSelect.setValue(this.JobsiteValues);
            },

            showNewJobsiteModal(){
                //Show it
                this.$refs.newJobsiteModal.show();
            },

            showNewEmployeeModal(){
                //Show it
                this.$refs.newEmployeeModal.show();
            },

            onEmployeeSelect(employee){
                this.incident.EmployeeId = employee.EmployeeId;
            },

            employeeCreated(employee){
                //How do we show the
                this.incident.EmployeeId = employee.EmployeeId;
                this.incident.EmployeeFirstName = employee.FirstName;
                this.incident.EmployeeLastName = employee.LastName;
                this.incident.EmployeeEmployeeNumber = employee.EmployeeNumber;

                //We have to call the employee-select helper function
                //because component props are ONE WAY databound.
                this.$refs.employeeSelector.setSelectedValues(this.EmployeeValues);
            },

            getIncident() {
                //Get the data
                this.$http
                    .get('incident/create')
                    .then(response => {
                        //Set all the data
                        this.incidentTypes = response.data.incidentTypes;
                        this.incidentTypeSettings = response.data.incidentTypeSettings;
                        this.incident = response.data.incident;
                        this.account = response.data.account;
                        this.subcontractors = response.data.subcontractors;

                        if (this.incident.EmployeeId === undefined)
                        {
                            this.$set(this.incident, 'EmployeeId', null);
                        }
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveIncident() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Set the helper
                this.incident.is_other_location = this.is_other_location;
                this.incident.no_jobsite_set = this.no_jobsite_set;

                //Send it
                this.$http
                .postWithFiles('incident/create', this.incident, this.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Incident Created');

                    //Return to main list?
                    this.$router.push('/incidents/edit/' + response.data.IncidentId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Create Incident');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            subcontractorCreated(subcontractor){
                //Do What?
                this.subcontractors.push(subcontractor);

                //Set the ID
                this.incident.subcontractor_id = subcontractor.subcontractor_id;
            },
        },

        mounted() {
            //Get the incidents
            this.getIncident();
        }
    }
</script>
